module.exports = __webpack_public_path__ + "images/icons/icon-payment-unionpay-9b59a572.svg";